module.exports = __webpack_public_path__ + "img/upload_cards.41c0fd90.svg";